import { PureComponent, Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isBrowser, isTablet } from 'react-device-detect';
import { filter } from 'lodash';
import moment from 'moment';

import {
  AvForm,
  AvField,
  AvCheckbox,
  AvCheckboxGroup,
} from 'availity-reactstrap-validation';

import {
  Button,
  Grid,
  Icon,
  Modal,
  Radio,
  Segment,
  Search,
  Label,
} from 'semantic-ui-react';

import {
  CustomTable,
  EmptyContainer,
  CustomTooltip,
} from '../../../../components';

import { map, debounce } from '../../../../utils/lodash';
import {
  postPermissionGroups,
  updatePermissionGroup,
  getFeatures,
  getPermissionGroups,
} from '../../../../store/actions';

import { isFeatureSelected } from '../../../../utils';

class PermissionGroups extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      modal: false,
      keyword: '',
    };
    this.LIMIT = 15;
  }

  async componentDidMount() {
    const { getPermissionGroups } = this.props;
    getPermissionGroups(this.state.currentPage);
  }

  pageChange = (page) => {
    const { getPermissionGroups } = this.props;
    this.setState(
      {
        currentPage: page,
      },
      () => {
        getPermissionGroups(page, this.LIMIT, this.state.keyword);
      }
    );
  };

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  handleSearchChange = (e, { value }) => {
    const { getPermissionGroups } = this.props;
    const pageNumber = 1;
    getPermissionGroups(pageNumber, this.LIMIT, value);
    this.setState({ currentPage: pageNumber, keyword: value });
  };

  render() {
    const { modal, currentPage } = this.state;
    const { t } = this.props;
    return (
      <div>
        <div className="outcome-admin">
          <div className="search-bar mr-3">
            <Search
              onSearchChange={debounce(this.handleSearchChange, 500)}
              placeholder={t('admin.system_feature.search_by_permission_name')}
              showNoResults={false}
            />
          </div>
          <div className="button-outcome">
            <Modal
              open={modal}
              onOpen={() => this.toggle()}
              closeIcon={
                <Icon
                  onClick={() => this.toggle()}
                  name="close"
                  className="closeicon"
                />
              }
              size="large"
              trigger={
                <Button className="Primary-Button">
                  <div className="add-icon-activity-add">
                    <Icon name="plus circle" />
                    <div className="add-text">
                      {t('admin.system_feature.add_permission_group')}
                    </div>
                  </div>
                </Button>
              }
              className="create-permission-group"
            >
              <Modal.Header>
                {t('admin.system_feature.create_permission_group')}
              </Modal.Header>
              <Modal.Content>
                <CreatePermissionGroups
                  toggle={() => this.toggle()}
                  pageChange={this.pageChange}
                  {...this.props}
                />
              </Modal.Content>
            </Modal>
          </div>
        </div>
        <PermissionGroupList
          currentPage={currentPage}
          pageChange={this.pageChange}
          {...this.props}
        />
      </div>
    );
  }
}
class CreatePermissionGroups extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: true,
      isVisible: true,
      selectedFeaturs: [],
      isSelectedFeatursEmpty: false,
    };
  }

  async componentDidMount() {
    const { getFeatures } = this.props;
    getFeatures(0);
  }

  handleActivateToggle() {
    this.setState((prevState) => ({
      isActive: !prevState.isActive,
    }));
  }

  handleVisbleToggle() {
    this.setState((prevState) => ({
      isVisible: !prevState.isVisible,
    }));
  }

  async handleValidSubmit(event, values) {
    try {
      const { postPermissionGroups, toggle, pageChange } = this.props;
      const { selectedFeaturs, isActive, isVisible } = this.state;
      if (!selectedFeaturs.length) {
        this.setState({ isSelectedFeatursEmpty: true });
        return;
      }
      values.isActive = isActive;
      values.isVisible = isVisible;
      values.features = selectedFeaturs;
      await postPermissionGroups(values);

      toggle();
      pageChange(1);
    } catch (error) {
      console.error('Permission create submit ~~', error);
    }
  }

  handelFeatureSelected(id) {
    const { selectedFeaturs, isSelectedFeatursEmpty } = this.state;
    if (isFeatureSelected(id, selectedFeaturs)) {
      if (selectedFeaturs.length === 1)
        this.setState({ isSelectedFeatursEmpty: true });
      this.setState({
        selectedFeaturs: filter(
          selectedFeaturs,
          (featureId) => featureId !== id
        ),
      });
    } else {
      this.setState((prevState) => ({
        selectedFeaturs: [...prevState.selectedFeaturs, id],
      }));
      if (isSelectedFeatursEmpty)
        this.setState({ isSelectedFeatursEmpty: false });
    }
  }

  featureSelectAll() {
    const { features } = this.props;
    if (features) {
      this.setState({
        selectedFeaturs: map(features.docs, (doc) => doc.id),
        isSelectedFeatursEmpty: false,
      });
    }
  }
  render() {
    const {
      toggle,
      postPermissionGroupLoading,
      features,
      getfeatureLoading,
      t,
    } = this.props;
    return (
      <AvForm
        ref={(c) => (this.form = c)}
        onValidSubmit={(event, values) => this.handleValidSubmit(event, values)}
        className="venue-form"
      >
        <AvField
          label={t('common.name')}
          className="org-inputs"
          name="name"
          type="text"
          validate={{
            required: {
              value: true,
              errorMessage: t('admin.system_feature.name_required'),
            },
          }}
        />

        <AvField
          label={t('common.description')}
          className="org-inputs-textarea"
          name="description"
          type="textarea"
          validate={{
            required: {
              value: true,
              errorMessage: t('formulary.validation.description_required'),
            },
          }}
        />
        <div className="featurelist-heder">
          <div className="button-container">
            <Button
              type="button"
              onClick={() => {
                this.featureSelectAll();
              }}
              className="Secondary-Button"
            >
              {t('admin.system_feature.select_all')}
            </Button>
            <Button
              type="button"
              onClick={() => {
                this.setState({ selectedFeaturs: [] });
              }}
              className="Secondary-Button"
            >
              {t('actions.clear_all')}
            </Button>
          </div>
        </div>
        <label>{t('common.features')}</label>

        <Segment
          className="content-segment mt-0"
          loading={getfeatureLoading}
          disabled={getfeatureLoading}
        >
          {features.docs && features.docs.length ? (
            <AvCheckboxGroup name="features">
              <Grid className="features-checkbox-container">
                {map(features.docs, (doc) => (
                  <Grid.Column
                    key={doc.id}
                    className="permission-features-list"
                    computer={5}
                    verticalAlign="middle"
                  >
                    <div className="features-checkbox">
                      <AvCheckbox
                        onChange={(e, value) => {
                          this.handelFeatureSelected(doc.id);
                        }}
                        checked={isFeatureSelected(
                          doc.id,
                          this.state.selectedFeaturs
                        )}
                        value={doc.id}
                        label={
                          <CustomTooltip
                            state={true}
                            content={doc.description}
                            position="top left"
                            wide="very"
                          >
                            <div
                              className={
                                this.state.isSelectedFeatursEmpty
                                  ? 'feature-err'
                                  : ''
                              }
                            >
                              {doc.displayName}
                            </div>
                          </CustomTooltip>
                        }
                      />
                    </div>
                  </Grid.Column>
                ))}
              </Grid>
            </AvCheckboxGroup>
          ) : (
            <EmptyContainer msg={t('admin.system_feature.no_features')} />
          )}
        </Segment>

        <Grid className="activate-notify-row">
          <Grid.Column
            computer={3}
            className="evaluation-activity-toggel-group linked-activity-model-column"
          >
            <label className="lbl-margin-left">
              {t('admin.system_feature.activate')}
            </label>
            <Radio
              toggle
              name="activateToggel"
              checked={this.state.isActive}
              onChange={() => this.handleActivateToggle()}
            />
          </Grid.Column>
          <Grid.Column
            computer={3}
            className="evaluation-activity-toggel-group linked-activity-model-column"
          >
            <label className="lbl-margin-left">
              {t('admin.system_feature.visibility')}
            </label>
            <Radio
              toggle
              name="visibleToggel"
              checked={this.state.isVisible}
              onChange={() => this.handleVisbleToggle()}
            />
          </Grid.Column>
        </Grid>
        <div className="model-buttons">
          <Button
            className="Secondary-Button"
            type="button"
            onClick={() => toggle()}
          >
            {t('actions.cancel')}
          </Button>
          <Button
            content={t('actions.create')}
            type="submit"
            className="Primary-Button"
            loading={postPermissionGroupLoading}
            disabled={postPermissionGroupLoading}
          />
        </div>
      </AvForm>
    );
  }
}

class EditPermissionGroupModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      form: {
        name: '',
        description: '',
      },
    };
  }

  editSelectedQuestion(form) {
    form.features = form.featureGroup
      ? map(form.featureGroup, (feature) => feature.featureId)
      : [];

    this.setState({
      form,
    });
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }
  render() {
    const { modal, form } = this.state;
    const { item, t } = this.props;

    return (
      <Modal
        open={modal}
        onOpen={() => this.toggle()}
        closeIcon={
          <Icon
            onClick={() => this.toggle()}
            name="close"
            className="closeicon"
          />
        }
        size="large"
        trigger={
          <label
            className="activity-actions-warn mb-0"
            onClick={() => this.editSelectedQuestion(item)}
          >
            {t('actions.edit')}
          </label>
        }
        className="edit-permission-group"
      >
        <Modal.Header>
          {t('specific_actions.edit_permission_group')}
        </Modal.Header>
        <Modal.Content>
          <EditPermissionForm
            form={form}
            toggle={() => this.toggle()}
            {...this.props}
          />
        </Modal.Content>
      </Modal>
    );
  }
}

class PermissionGroupList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
    };
  }

  getColumns() {
    const { t, i18n } = this.props;
    return [
      {
        title: (
          <div>
            <strong>{t('common.permission')}</strong>
          </div>
        ),
        render: (data) => {
          return (
            <div className="blocked-badge-container">
              <div className={!data.isActive && 'disabled'}> {data.name}</div>
              {!data.isActive && (
                <Label className="blocked-badge" color="red" size="tiny">
                  {t('common.disabled')}
                </Label>
              )}
            </div>
          );
        },
        width: 3,
        textAlign: isBrowser || isTablet ? 'left' : null,
      },
      {
        title: (
          <div className="user-act-heading-container-custom-feature">
            <strong>{t('common.description')}</strong>
          </div>
        ),
        render: (data) => {
          return (
            <div className={!data.isActive && 'disabled'}>
              {' '}
              {data.description}
            </div>
          );
        },
        width: 4,
        textAlign: isBrowser || isTablet ? 'left' : null,
      },
      {
        title: (
          <div className="user-act-heading-container-custom-feature">
            <strong>{t('common.created_date')}</strong>
          </div>
        ),
        render: (data) => {
          return (
            <div className={!data.isActive && 'disabled'}>
              {' '}
              {new Intl.DateTimeFormat(i18n.language, {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
              }).format(new Date(data.createdAt))}
            </div>
          );
        },
        width: 3,
        textAlign: isBrowser || isTablet ? 'left' : null,
      },
      {
        title: (
          <div className="user-act-heading-container-custom-feature">
            <strong>{t('common.updated_date')}</strong>
          </div>
        ),
        render: (data) => {
          return (
            <div className={!data.isActive && 'disabled'}>
              {' '}
              {new Intl.DateTimeFormat(i18n.language, {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
              }).format(new Date(data.updatedAt))}
            </div>
          );
        },
        width: 3,
        textAlign: isBrowser || isTablet ? 'left' : null,
      },
      {
        title: (
          <div className="user-act-heading-container-custom-feature">
            <strong>{t('admin.system_feature.visibility')}</strong>
          </div>
        ),
        render: (data) => {
          return (
            <div className={!data.isActive && 'disabled'}>
              {' '}
              <div className="active-status-container">
                {data.isVisible ? (
                  <div className="active-status">
                    {t('admin.system_feature.visible')}
                  </div>
                ) : (
                  <div className="block-status">
                    {t('admin.system_feature.not_visible')}
                  </div>
                )}
              </div>
            </div>
          );
        },
        width: 2,
        textAlign: isBrowser || isTablet ? 'centre' : null,
      },
      {
        title: <div></div>,
        render: (data) => {
          const { currentPage } = this.props;
          return (
            <div className="venue-edit">
              <EditPermissionGroupModal
                item={data}
                currentPage={currentPage}
                {...this.props}
              />
            </div>
          );
        },
        width: 1,
        textAlign: isBrowser || isTablet ? 'left' : null,
      },
    ];
  }

  async componentDidMount() {
    try {
      const { currentPage, getPermissionGroups } = this.props;
      await getPermissionGroups(currentPage);
    } catch (error) {}
  }

  pageChange(page) {
    const { getPermissionGroups } = this.props;
    this.setState(
      {
        currentPage: page,
      },
      () => {
        getPermissionGroups(page);
      }
    );
  }

  render() {
    const {
      getPermissionGroup,
      getPermissionLoading,
      pageChange,
      currentPage,
      t,
    } = this.props;
    return (
      <Segment
        className="content-segment p-0"
        loading={getPermissionLoading}
        disabled={getPermissionLoading}
      >
        {getPermissionGroup.docs ? (
          <CustomTable
            header
            columns={this.getColumns()}
            data={getPermissionGroup.docs}
            pagination
            keyExtractor={(item, index) => item.id}
            customClass="super-admin-table tbody-hover"
            handlePaginationChange={(page) => pageChange(page)}
            page={currentPage}
            noOfPages={getPermissionGroup.pages}
          />
        ) : (
          <EmptyContainer
            msg={t('admin.system_feature.no_permission_grants')}
          />
        )}
      </Segment>
    );
  }
}
class EditPermissionForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: true,
      isActive: true,
      selectedFeaturs: [],
      isSelectedFeatursEmpty: false,
    };
  }

  async componentDidMount() {
    const { getFeatures, form } = this.props;
    getFeatures(0);
    if (!form.isVisible) {
      this.setState({
        isVisible: false,
      });
    }

    if (!form.isActive) {
      this.setState({
        isActive: false,
      });
    }

    this.setState({
      selectedFeaturs: form.features,
    });
  }

  async onValidSubmit(event, values) {
    const formData = { name: values.name, description: values.description };
    try {
      const { updatePermissionGroup, form, toggle, currentPage } = this.props;
      const { selectedFeaturs, isVisible, isActive } = this.state;
      if (!selectedFeaturs.length) {
        this.setState({ isSelectedFeatursEmpty: true });
        return;
      }
      formData.isVisible = isVisible;
      formData.isActive = isActive;
      formData.features = selectedFeaturs;
      await updatePermissionGroup(form.id, formData, currentPage);
      toggle();
    } catch (error) {
      // handle error here
    }
  }

  handleVisbleToggle() {
    this.setState((prevState) => ({
      isVisible: !prevState.isVisible,
    }));
  }

  async handelFeatureSelected(id) {
    const { selectedFeaturs, isSelectedFeatursEmpty } = this.state;
    const isd = await isFeatureSelected(id, selectedFeaturs);
    if (isd) {
      if (selectedFeaturs.length === 1)
        this.setState({ isSelectedFeatursEmpty: true });
      this.setState({
        selectedFeaturs: filter(
          selectedFeaturs,
          (featureId) => featureId !== id
        ),
      });
    } else {
      this.setState({ selectedFeaturs: [...selectedFeaturs, id] });
      if (isSelectedFeatursEmpty)
        this.setState({ isSelectedFeatursEmpty: false });
    }
  }

  featureSelectAll() {
    const { features } = this.props;
    if (features) {
      this.setState({
        selectedFeaturs: map(features.docs, (doc) => doc.id),
        isSelectedFeatursEmpty: false,
      });
    }
  }

  handleActivateToggle() {
    this.setState((prevState) => ({
      isActive: !prevState.isActive,
    }));
  }

  render() {
    const {
      toggle,
      form,
      updatePermissionGroupLoading,
      features,
      getfeatureLoading,
      t,
    } = this.props;
    const { selectedFeaturs } = this.state;

    return (
      <AvForm
        ref={(c) => (this.form = c)}
        onValidSubmit={(event, values) => this.onValidSubmit(event, values)}
        className="venue-form"
        model={form}
      >
        <AvField
          label={t('formulary.title')}
          className="org-inputs"
          name="name"
          type="text"
          validate={{
            required: {
              value: true,
              errorMessage: t('formulary.validation.title_required'),
            },
          }}
        />

        <AvField
          label={t('common.description')}
          className="org-inputs-textarea"
          name="description"
          type="textarea"
          validate={{
            required: {
              value: true,
              errorMessage: t('formulary.validation.description_required'),
            },
          }}
        />

        <div className="featurelist-heder">
          <div className="button-container">
            <Button
              type="button"
              onClick={() => {
                this.featureSelectAll();
              }}
              className="Secondary-Button"
            >
              {t('admin.system_feature.select_all')}
            </Button>
            <Button
              type="button"
              onClick={() => {
                this.setState({ selectedFeaturs: [] });
              }}
              className="Secondary-Button"
            >
              {t('actions.clear_all')}
            </Button>
          </div>
        </div>
        <label>{t('common.features')}</label>
        <Segment
          className="content-segment mt-0"
          loading={getfeatureLoading}
          disabled={getfeatureLoading}
        >
          {features.docs && features.docs.length ? (
            <AvCheckboxGroup name="features_">
              <Grid className="features-checkbox-container">
                {map(features.docs, (doc) => (
                  <Grid.Column
                    key={doc.id}
                    className="permission-features-list"
                    computer={5}
                    verticalAlign="middle"
                  >
                    <div className="features-checkbox">
                      <AvCheckbox
                        onChange={(e, value) => {
                          this.handelFeatureSelected(doc.id);
                        }}
                        checked={isFeatureSelected(doc.id, selectedFeaturs)}
                        value={doc.id}
                        label={
                          <CustomTooltip
                            state={true}
                            content={doc.description}
                            position="top left"
                            wide="very"
                          >
                            <div
                              className={
                                this.state.isSelectedFeatursEmpty
                                  ? 'feature-err'
                                  : ''
                              }
                            >
                              {doc.displayName}
                            </div>
                          </CustomTooltip>
                        }
                      />
                    </div>
                  </Grid.Column>
                ))}
              </Grid>
            </AvCheckboxGroup>
          ) : (
            <EmptyContainer msg={t('admin.system_feature.no_features')} />
          )}
        </Segment>

        <Grid className="activate-notify-row mt-3">
          <Grid.Column
            computer={3}
            className="evaluation-activity-toggel-group linked-activity-model-column"
          >
            <label className="lbl-margin-left">
              {t('admin.system_feature.activate')}
            </label>
            <Radio
              toggle
              name="activateToggel"
              checked={this.state.isActive}
              onChange={() => this.handleActivateToggle()}
            />
          </Grid.Column>
          <Grid.Column
            computer={3}
            className="evaluation-activity-toggel-group linked-activity-model-column"
          >
            <label className="lbl-margin-left">
              {t('admin.system_feature.visibility')}
            </label>
            <Radio
              toggle
              name="visibleToggel"
              checked={this.state.isVisible}
              onChange={() => this.handleVisbleToggle()}
            />
          </Grid.Column>
        </Grid>

        <div className="model-buttons">
          <Button
            className="Secondary-Button"
            type="button"
            onClick={() => toggle()}
          >
            {t('actions.cancel')}
          </Button>
          <Button
            content={t('actions.save')}
            type="submit"
            className="Primary-Button"
            loading={updatePermissionGroupLoading}
            disabled={updatePermissionGroupLoading}
          />
        </div>
      </AvForm>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    PermissionGroups: state.extra.PermissionGroups,
    updatePermissionGroupLoading: state.admin.updatePermissionGroupLoading,
    getPermissionGroup: state.admin.getPermissionGroup,
    getPermissionLoading: state.admin.getPermissionLoading,
    deletePermissionLoading: state.admin.deletePermissionLoading,
    features: state.admin.features,
    getfeatureLoading: state.admin.getfeatureLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      postPermissionGroups,
      updatePermissionGroup,
      getPermissionGroups,
      getFeatures,
    },
    dispatch
  );
};

PermissionGroups = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(PermissionGroups));

CreatePermissionGroups = withTranslation()(CreatePermissionGroups);
EditPermissionGroupModal = withTranslation()(EditPermissionGroupModal);
PermissionGroupList = withTranslation()(PermissionGroupList);
EditPermissionForm = withTranslation()(EditPermissionForm);

export { PermissionGroups };
